















import ReportGroupTable from "@/components/report/group/ReportGroupTable.vue";
import Debug from "@/components/utility/Debug.vue";
import { IBreadcrumb } from "@/lib/interfaces/utility/breadcrumb-interface";
import MHeader, { IAction } from "@/components/utility/mmmint/MHeader.vue";
import TheLayoutPortal from "@/layouts/TheLayoutPortal.vue";
import { ReportGoToHelper } from "@/lib/utility/report.go-to-helper";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { $t } from "@/lib/utility/t";
import PartnerFallbackMixin from "@/mixins/PartnerFallbackMixin.vue";
import { MrfiktivReferenceGen } from "@/services/mrfiktiv/v1/data-contracts";
import { ReportGroupModule } from "@/store/modules/report-group.store";
import { mixins } from "vue-class-component";
import { Component, Ref } from "vue-property-decorator";
import { IReportGroup, ReportGroup } from "@/models/report-group.entity";

@Component({
  components: {
    ReportGroupTable,
    Debug,
    TheLayoutPortal,
    MHeader
  },
  filters: {
    simpleDoubleDigitDate
  }
})
export default class ReportGroupTableView extends mixins(PartnerFallbackMixin) {
  @Ref("reportGroupTable")
  reportGroupTable!: ReportGroupTable;

  readonly AMOUNT_COMPANY_GROUP = "amountReportGroup";

  /**
   * refs that will be set in new companies and filtered (via or) for in table
   */
  refs: MrfiktivReferenceGen[] = [];

  get partnerId(): string {
    return this.$route.params.partnerId;
  }

  get breadCrumbList(): IBreadcrumb[] {
    const crumbs: IBreadcrumb[] = [];

    crumbs.push(ReportGoToHelper.breadCrumbs.ReportGroupTable(this.partnerId));

    return crumbs;
  }

  get chips(): IAction[] {
    return [
      {
        text: `${ReportGroupModule.totalItems} ${this.$t("report.reportGroups")}`,
        key: this.AMOUNT_COMPANY_GROUP,
        disabled: true
      }
    ];
  }

  get actions(): IAction[] {
    return [
      {
        text: $t("report.allReports"),
        key: "allReports",
        exec: () => new ReportGoToHelper(this.$router).goToReportTable({ partnerId: this.partnerId })
      }
    ];
  }

  async mounted() {
    await this.trySetByRouteOrDefault();

    const reportGroupId = this.$route.query.reportGroupId as string;
    if (reportGroupId) {
      const reportGroup = new ReportGroup({ partnerId: this.partnerId, id: reportGroupId });
      this.reportGroupTable?.setSelectedItem(reportGroup);
    }
  }

  openSideCard(reportGroup: IReportGroup) {
    new ReportGoToHelper(this.$router).setUrl(
      ReportGoToHelper.locations.reportGroupTable({
        partnerId: this.partnerId,
        query: reportGroup ? { reportGroupId: reportGroup.id } : {}
      })
    );
  }
}
